module.exports = __webpack_public_path__ + "static/predictivepoem 27-01-b79d5e0d7a814f3072ad7caa9c9bdce7.jpg";